if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.fetchRecommendations();
              obs.unobserve(this);
            }
          });
        }, { rootMargin: '200px' });
        observer.observe(this);
      } else {
        this.fetchRecommendations();
      }
    }

    async fetchRecommendations() {
      const url = this.dataset.url;
      if (!url) {
        this.hideSection();
        return;
      }

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Failed to fetch recommendations');

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('product-recommendations');

        if (newContent && newContent.innerHTML.trim()) {
          this.innerHTML = newContent.innerHTML;
          // Force style recalc so cards paint with correct aspect-ratio / grid
          // on first frame instead of flashing unstyled until next interaction.
          void this.offsetHeight;
          this.initializeSlider();
          this.showSection();
        } else {
          this.hideSection();
        }
      } catch (error) {
        console.error('Error fetching product recommendations:', error);
        this.hideSection();
      }
    }

    initializeSlider() {
      const slider = this.querySelector('component-slider');
      if (slider) {
        if (slider.eventsDeclared) {
          slider.removeEventListeners();
          slider.eventsDeclared = false;
        }
        if (typeof slider.setUpSlider === 'function') {
          slider.setUpSlider();
        }
      }
    }

    hideSection() {
      const section = this.closest('.section-related-products');
      if (section) {
        section.style.display = 'none';
      }
    }

    showSection() {
      const section = this.closest('.section-related-products');
      if (section) {
        section.style.display = '';
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
